<template>
    <div class="board h-full relative" >
        <DashboardLayout
            :boardOverviewFunc="getBoards"
            class="h-full dashboard-layout"
            @showUploadState="showUploadState"
        >
            <div class="root h-full page-content-container">
                <div v-if="!boards?.length && boardsLoaded && $route.name === 'Project'" class="create-board-from-board">
                    Please create a new project!
                    <VButton @clickHandler="$children[0].$children[0].$refs['new-board'].showModal()">Create</VButton>

                    <div class="smart-list-card-wrap">
                        <div class="smart-list-card">
                            <h2>Welcome</h2>
                            <p>Welcome to your new home, take a ride by watching the following video.</p>
                            <div class="smart-list-video">
                                <iframe
                                    width="100%" 
                                    height="100%" 
                                    src="https://www.youtube.com/embed/nPXdlwVk0G0?si=AMdflcFBg2VRmB38" title="YouTube video player" 
                                    frameborder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                    allowfullscreen>
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <router-view
                    :board_id="activeBoard?.id"
                    :currentUser="currentUser"
                    :boardOverviewFunc="getBoards"
                    :getBoardUpdates="getBoards"
                    :dragScroll="dragScroll"
                    @showUploadState="showUploadState"
                    @eventsSubscribtion="eventsSubscribtion"
                    :tasksIntervalRun="tasksIntervalRun"
                    v-if="boards"
                ></router-view>

                <div class="goleko-watermark">
                    <img src="@/assets/images/goleko-watermark.svg" alt="">
                    <div>Version: {{ version.commit.slice(0, 8) }}</div>
                    <div
                        v-if="isStagingWatermarkVisible"
                        class="staging-env"
                    >Staging enviroment</div>
                </div>
            </div>
        </DashboardLayout>

        <VModal ref="new-version-modal" class="save-changes-modal new-version-modal cant-hide" size="sm">
            <p class="mb-3">
                We just released an new version, please do an hard refresh to continue. <br>
                You might have to login again.
            </p>
            <p>Windows: press [CTRL] + F5</p>
            <p>MacOS: Press [Command] + R</p>
            <p>Linux: You know what to do</p>
        </VModal>

        <ConflictSavingModal
            id="conflict-saving"
            ref="conflict-saving"
            :task_body_my="task_body_my"
            :task_body_theirs="task_body_theirs"
            @saveMyVersion="saveMyVersion"
        />

        <Flash ref="show"/>

        <UploadingStatus ref="upload-status"/>

        <VModal ref="limit-modal" class="limit-modal" size="md">
            <div class="text-holder">
                <p>You have been reached limit of {{ planLimit }}<br>
                    To expand your opportunities, please upgrade to higher plan.</p>
            </div>
            <VButton @clickHandler="showUpgradeModal" active>Upgrade</VButton>
            <div>
                <a href="#" @click.prevent="cancelUpgrading">No, thanks</a>
            </div>
        </VModal>
        <VModal ref="upgrade-modal" class="upgrade-modal" size="lg">
            <div class="row">
                <div
                    class="col"
                    v-for="(plan, p) in billingPlans.filter(plan => plan.show_plan)"
                    :key="p"
                >
                    <BillingPlan
                        :title="plan.title"
                        :name="plan.name"
                        :price="plan.price"
                        :max_gb="plan.gb"
                        :max_projects="plan.projects"
                        :max_members="plan.members"
                        :max_tasks="plan.tasks"
                        :max_rec_time="plan.rec_time"
                        :draw_images="plan.draw_images"
                    />
                </div>
            </div>
        </VModal>
    </div>
</template>

<script>
import {api} from "@/mixins/axios";
import {Container, Draggable} from "vue-smooth-dnd";
import {applyDrag, difference} from "@/mixins/helpers";
import Flash from "@/components/Flash.vue";
import VButton from "@/components/atoms/VButton";
import Textfield from "@/components/atoms/Textfield.vue";
import DashboardLayout from "@/components/organism/DashboardLayout.vue";
import { mapActions } from 'vuex';
import VModal from "@/components/atoms/VModal.vue";
import ConflictSavingModal from "@/components/molecules/ConflictSavingModal.vue";
import LoaderAnimationVue from "@/components/atoms/LoaderAnimation.vue";
import UploadingStatus from "@/components/molecules/UploadingStatus.vue";
import BillingPlan from "@/components/atoms/BillingPlan.vue";

export default {
    name: "BoardLayout",
    components: {
        VButton,
        Container,
        Draggable,
        Flash,
        Textfield,
        DashboardLayout,
        VModal,
        ConflictSavingModal,
        LoaderAnimationVue,
        UploadingStatus,
        BillingPlan
    },
    props: ["token"],
    data: function () {
        return {
            task: {
                id: "",
                title: "",
                body: "",
                tags: [],
                is_template: false,
            },
            tasks: [],
            member: {
                email: "",
                role: "member",
                project: "",
            },
            cacheTimerRenewLock: null,
            board: {
                title: "",
            },
            lock: "",
            newList: {
                title: "",
            },
            list: {
                title: "",
                tags: [],
                listIndex: "",
                boardIndex: "",
                listPosition: "",
                openListOptions: false,
                openNewTask: false
            },
            tags: [],
            edit_modal_toggle: false,
            task_body_my: "",
            task_body_theirs: "",
            from_task: false,
            projectOrder: [],
            version: aboutUs,
            boardsLoaded: false,
            isStagingWatermarkVisible: false,
            subscribeAfter: null,
            eventSource: null,
            tasksIntervalRun: null
        };
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser
        },
        boards() {
            return this.$store.getters.boards
        },
        members() {
            return this.$store.getters.members
        },
        userID() {
            return this.$store.getters.userID
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        events2() {
            return this.$store.getters.events2
        },
        backgroundColor() {
            return this.$store.getters.backgroundColor
        },
        planLimit() {
            return this.$store.getters.planLimit
        },
        billingPlans() {
            return this.$store.getters.billingPlans
        }
    },
    async created() {
        this.userAuth()
    },
    mounted() {
        // Board height based on if nav is hidden
        const hideNavbarLS = JSON.parse(localStorage.getItem('hideNavbar')) || false
        if (!hideNavbarLS) {
            document.querySelector('.page-content-container').classList.add('nav-shown-mode')
        } else {
            document.querySelector('.page-content-container').classList.remove('nav-shown-mode')
        }

        if (!this.activeBoard && this.boards) {
            this.$store.dispatch('setActiveBoard', this.boards[0]?.id);
        }

        if (location.hostname === '1.goleko.com') {
            this.isStagingWatermarkVisible = true;
        }
    },
    methods: {
        eventsSubscribtion() {
            let initLoad = true
            let initTime = new Date()
            let baseURL = api.defaults.baseURL.replace('/api', '')
            let userID = this.userID ? this.userID : localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')).id : ''
            let url = `${baseURL}/api/subscribe?id=${userID}`
            console.log(this.subscribeAfter ? this.formatDate(this.subscribeAfter) : null)
            this.eventSource = new EventSource(this.subscribeAfter ? `${url}&after=${this.formatDate(this.subscribeAfter)}` : url);

            this.eventSource.addEventListener('message', (event) => {
                const data = JSON.parse(event.data);
                this.$store.dispatch('addEvents2', data);
                this.tasksIntervalRun = {
                    event: data,
                    afterLoad: this.compareDates(initTime, data.created * 1000)
                }
                this.subscribeAfter = data.created
            });

            this.eventSource.addEventListener('open', (event) => {
                if(this.subscribeAfter) {
                    initTime = this.subscribeAfter * 1000
                }

                if(!initLoad) {
                    this.eventSource.close()
                    this.eventSource = null;
                    this.eventsSubscribtion()
                    this.$refs.show.showFlashSuccess(`You're back online`)
                    initLoad = true
                }
                
                if(!initLoad && !this.userID) {
                    this.$router.go()
                }
            });

            this.eventSource.addEventListener('error', (event) => {
                this.$refs.show.showFlashWarning(`Lost connection...`)
                this.tasksIntervalRun = null
                initLoad = false
            });
        },
        formatDate(timestamp) {
            let utcDate = new Date(timestamp * 1000);
            let offsetMinutes = -utcDate.getTimezoneOffset();
            let offsetHours = Math.floor(offsetMinutes / 60);
            let offsetMinutesRemainder = Math.abs(offsetMinutes % 60);
            console.log(utcDate.toISOString())
            let timezoneOffset = `${offsetHours >= 0 ? '%2B' : '-'}${Math.abs(offsetHours).toString().padStart(2, '0')}:${offsetMinutesRemainder.toString().padStart(2, '0')}`;
            let formattedDate = utcDate.toISOString().replace(/T/, ' ').replace(/Z/, timezoneOffset);
            console.log(formattedDate)
			return formattedDate
        },
        compareDates(d1, d2) {
            let date1 = new Date(d1).getTime();
            let date2 = new Date(d2).getTime();
            
            if (date1 < date2) return 1
            else if (date1 > date2) return -1
            else return 0
        },
        async userAuth() {
            if(this.$route.query.tmp_code) {
                try {
                    const response = await api.post("/user_login_with_tmp_code", {tmp_code: this.$route.query.tmp_code});
                    if(response.data.msg === 'ok') {
                        // this.$store.dispatch('auth', response.data.data);
                        localStorage.setItem('token', response.data.token);
                        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                        
                        if (this.$route.params.board_id) {
                            location.href = `/app/project/${this.$route.params.board_id}`
                        }
                        
                        await this.getBoards()
                    }
                } catch (e) {
                    if (e.response.data.msg.includes('Invalid or expired link')) {
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    return
                }
            }
            try {
                const response = await api.post("/user_me", {});
                if (response.data.msg === 'ok') {
                    this.$store.dispatch('setCurrentUser', response.data.data);
                    let data = {}
                    data['token'] = localStorage.getItem('token');
                    data['user'] = response.data.data;
                    data['user']['id'] = response.data.data.id;
                    this.$store.dispatch('auth', data);
                    
                    await this.getBoards();
                    if (!this.board_id) this.board_id = this.boards[0]?.id

                    await this.updateBoardData()
                    await this.getTags();
                    
                    if (this.$route.path == '/' && this.$route.name !== 'TaskModal') {
                        //this.$router.replace(`/project/${this.boards[0]?.id}`);
                    }
                } else {
                    this.$refs['new-version-modal'].showModal()
                    if (!this.activeBoard && this.boards) {
                        this.$store.dispatch('setActiveBoard', this.boards[0]?.id);
                    }

                    await this.getTags();
                    if (this.$route.path == '/' && this.$route.name !== 'TaskModal' && this.boards) {
                        this.$router.replace(`/project/${this.boards[0]?.id}`);
                    }
                }
            } catch (e) {
                if(e?.response?.data?.msg) {
                    this.$refs.show.showFlashError(e?.response?.data?.msg)
                    localStorage.clear()
                    this.$router.push('/login')
                }
            }
        },
        renewLock() {
            this.cacheTimerRenewLock = setInterval(() => {
                if (this.edit_modal_toggle) {
                    this.lockTaskRenew();
                }
            }, 20000);
        },
        async getTags() {
            if (this.activeBoard['id'] && this.boards) {
                const currentBoard = this.boards.filter(board => board.id === this.activeBoard['id'])
                this.tags = currentBoard[0] && currentBoard[0].tags
            }
        },
        async taskEditField(field, value) {
            if (!api.online) {
                this.$refs.show.showFlashWarning(
                    "Lost connection, can't guarantee saving",
                );
                return;
            }

            if (!this.lock) {
                this.$refs.show.showFlashWarning("Lock missing");
                return;
            }

            const data = {
                id: this.task.id,
                [field]: value,
                lock_id: this.lock,
            };

            try {
                const response = await api.post(`/task_update`, data);

                if (response.data.msg === "ok") {
                    this.$refs['conflict-saving'].$refs['conflict-saving'].hideModal()
                }
            } catch (e) {
                console.error(e);
            }
        },
        async lockTaskRenew() {
            if (!this.lock) return;
            if (this.edit_modal_toggle === false) return;

            const {id} = this.task;
            const data = {
                id,
                seconds: 20,
                lock_id: this.lock,
            };

            try {
                const response = await api.post(`/task_renew_lock`, data);
            } catch (e) {
                console.error(e);
                clearInterval(this.cacheTimerRenewLock);
                if (!api.online) {
                    this.$refs.show.showFlashWarning(
                        "Lost connection, can't guarantee saving",
                    );
                }
            }
        },
        async lockTask() {
            if (!api.online) {
                this.$refs.show.showFlashWarning(
                    "Lost connection, can't guarantee saving",
                );
                return;
            }
            const {id} = this.task;
            const data = {id, seconds: 20};
            try {
                const response = await api.post(`/task_lock`, data);
                if (response.data.msg === "ok") {
                    this.edit_modal_toggle = !this.edit_modal_toggle
                    this.lock = response.data.lock;

                    this.task.body = response.data.body;

                    if (this.lock) {
                        this.renewLock();
                    }
                }
            } catch (e) {
                if (e.response.data.lock_user) {
                    clearInterval(this.cacheTimerRenewLock)
                    this.edit_modal_toggle = false
                    // TODO use user name instead
                    this.$refs.show.showFlashWarning(`Already locked by ${e.response.data.lock_user || "Unknown user"}`);
                } else {
                    this.$refs.show.showFlashError(e.response.data.msg);
                }
            }
        },
        async unlockTask() {
            if (!this.task.id) {
                return
            }
            try {
                let data = {
                    id: this.task.id,
                };
                const response = await api.post(`/task_unlock`, data);

            } catch (e) {
                console.error(e);
            }
        },
        async saveMyVersion(task_body_my) {
            this.task_body_my = task_body_my;
            await this.lockTask()
            // await this.taskEditField('body', this.task_body_my)
            await this.taskEditField('body', this.task.body)
            clearInterval(this.cacheTimerRenewLock)
            this.unlockTask()
        },
        async getBoards() {
            try {
                let data = {
                    page: 1,
                    paginate_by: 20
                };

                const response = await api.post(`/project_overview`, data);
                if (response.status === 200) {
                    this.$store.dispatch('setUsers', response.data.users);
                    if (!response.data.data) response.data.data = []
                    if (response.data.data.length == 0 &&  this.$route.path == '/') {
                        location.href = '/app/project/none'
                    } else if(response.data.data.length > 0 &&  this.$route.path == '/project/none') {
                        this.$router.push(`/project/${response.data.data[0].id}`)
                    }

                    // if(response.data.data.length > 0 && !this.$route.params.board_id && this.$route.name !== 'TaskModal') {
                    //     this.$router.push(`/project/${response.data.data[0].id}`)
                    // }

                    const updatedBoards = response.data.data?.map(board => {
                        const updatedMembers = board.members.map(memberId => {
                            if (response.data.users && response.data.users.length > 0) {
                                const user = response?.data?.users?.find(user => user?.id == memberId);
                                if (user) {
                                    const { ...userInfo } = user;
                                    return userInfo;
                                }
                            }
                        });

                        return { ...board, members: updatedMembers };
                    });

                    if (!this.currentUser?.project_order || this.currentUser?.project_order.trim() == "") {
                        this.$store.dispatch('setBoards', updatedBoards);
                    } else {
                        const boardsMap = new Map(updatedBoards.map(board => [board.id, board]));
                        const currentUserProjectOrder = this.currentUser?.project_order.split(',');
                        
                        this.projectOrder = currentUserProjectOrder
                            .map(boardId => boardsMap.get(Number(boardId)))
                            .filter(board => board);
                        
                        const missingBoards = updatedBoards.filter(board => !currentUserProjectOrder.includes(String(board.id)));
                        if (missingBoards.length) {
                            this.projectOrder = [...missingBoards, ...this.projectOrder]
                        }
                        this.$store.dispatch('setBoards', this.projectOrder);
                    }
                    this.boardsLoaded = true

                    if(this.$route.params.board_id && this.$route.name !== 'TaskModal') {
                        this.$store.dispatch('setActiveBoard', this.$route.params.board_id);
                    } else if(!this.$route.params.board_id && this.$route.name !== 'TaskModal') {
                        this.$store.dispatch('setActiveBoard', this.boards[0].id);
                        this.$router.replace(`/project/${this.boards[0].id}`)
                    }
                    if (this.activeBoard?.color.length > 0) {
                        this.$store.dispatch('setBackgroundColor', this.activeBoard?.color);
                        document.body.style.background = this.backgroundColor
                    }
                    
                    const a = this.boards && this.boards.length && this.boards?.filter(board => board?.id == this.activeBoard?.id)[0]
                    document.title = a && a.title ? `${a.title} | Goleko` : 'Goleko'
                }
            } catch (e) {
                console.error(e);
                if(e?.response?.data?.msg) {
                    this.$refs.show.showFlashError(e?.response?.data?.msg)
                    localStorage.clear()
                    this.$router.push('/login')
                }
            }
        },
        findParentTag(el, tag) {
			while(el.parentNode) {
				el = el.parentNode;
				if (tag == el) return el;
			}
			return null;
		},
        dragScroll() {
            const container = document.querySelector('.lists');
            if(container == null) return

            let isDragging = false;
            let startX = 0;
            let scrollLeft = 0;

            container?.addEventListener('pointerdown', (e) => {
                let extraСondition = this.$route.name == 'TimeTable' ? this.findParentTag(e.target, container) : false
                if (e.pointerType === 'mouse' && (e.target == container || extraСondition)) {
                    isDragging = true;
                    startX = e.pageX - container.offsetLeft;
                    scrollLeft = container.scrollLeft;
                }
            });

            document.addEventListener('pointerup', () => {
                if (isDragging) {
                    isDragging = false;
                }
            });

            document.addEventListener('pointermove', (e) => {
                if (!isDragging) return;
                const x = e.pageX - container.offsetLeft;
                const walk = (x - startX) * 1.5;
                container.scrollLeft = scrollLeft - walk;
            });
        },
        async showUploadState(files, taskID) {
            console.log('showUploadState mainBoardLayout')
            this.$refs['upload-status'].init(files, taskID)
        },
        cancelUpgrading() {
            this.$store.dispatch('updatePlanLimit', null);
            this.$refs['limit-modal'].hideModal()
        },
        showUpgradeModal() {
            this.$refs['limit-modal'].hideModal()
            this.$refs['upgrade-modal'].showModal()
        }
    },
    watch: {
        planLimit(val) {
            if(val) {
                this.$refs['limit-modal'].showModal()
            }
        }
    }
};
</script>

<style lang="scss">
.goleko-watermark {
    position: absolute;
    bottom: 30px;
    right: 50px;
    opacity: .5;
    pointer-events: none;

    div {
        color: #c1c1c1;
        margin-top: -10px;
        text-align: center;
        font-size: 13px;
    }

    .staging-env {
        margin-top: 5px;
        padding: 10px;
        color: white;
        background-color: rgb(255 0 0 / 72%);
    }
}

.create-board-from-board {
    padding: 20px !important;
    color: #fff;
    a {
        margin-left: .6rem;
    }
}

.nav-shown-mode {
    max-height: calc(100% - 53px);
}

.smart-list-card-wrap {
    position: absolute;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    width: 95%;
    max-width: 600px;
    backdrop-filter: blur(6px);
    
    
    .smart-list-card {
        padding: 10px 34px 24px;
        z-index: 99;
        background: var(--primary-bg);
        border-radius: 10px;
        border: 1px solid var(--outline);
        backdrop-filter: blur(6px);
        margin: 0 auto;
        // min-height: 420px;
        height: 100%;

        h2 {
            margin-top: 10px;
            margin-bottom: 10px;
            color: #BB9BFF;
            font-size: 31.2px;
            font-weight: 400;
            line-height: 34.08px;
        }
        h3 {
            color: #DC8B2B;
            font-size: 19px;
            font-weight: 400;
            line-height: 142%;
            margin-bottom: 25px;
        }
        p {
            font-size: 18.2px;
            font-weight: 300;
            line-height: 142%;
            margin-bottom: 25px;
        }
        .smart-list-video {
            height: 300px;
            margin-top: 40px;
            iframe {
                border-radius: 6px;
            }
        }
    }
}

.new-version-modal {
    background-color: rgba(11, 17, 19, 0.97) !important;
}

.limit-modal {
    text-align: center;

    .text-holder {
        background: var(--secondary-bg);
        color: var(--primary-text);
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 20px;

        p {
            margin-bottom: 0;
        }
    }

    .btn {
        margin-bottom: 15px;
    }
}

.upgrade-modal {
    .row {
        display: flex;

        .col {
            width: 33.332%;
        }
    }
}
</style>
